import * as Update from '../../update/index';
import * as UIToolkit from '../../UIToolkit/index';
import * as ShelfRenderCore from './renderCore/index';

export default function shelfUpdate(params: ShelfUpdateParams): void {
    if (params.onlyUpdateClass) {
        // 货架索引标记class
        ShelfRenderCore.addShelfIndexClass(params.cube);
        return;
    }
    UIToolkit.shelfChildSortByPosition(params.cube.id);
    UIToolkit.targetShelfsLayerHeight(params.cube.id);
    Update.updateDepByCubeId(params.cube.id);
    ShelfRenderCore.addShelfIndexClass(params.cube);
}
